import { Dispatch, FC, SetStateAction } from 'react';
import { typeMeeting } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    meetings: typeMeeting[];
    monthFilter: string;
    setMonthFilter: Dispatch<SetStateAction<string>>;
};

export const MeetingAttendanceTableFilter: FC<propsType> = ({ meetings, monthFilter, setMonthFilter }) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <>
        <h2 className={`${isDarkMode ? 'text-white' : ''} text-center mb-4`}>
            Asistencias Registradas
        </h2>
        <div className={'mx-auto mb-4'} style={{ maxWidth: '250px' }}> 
            <select className={'form-select text-center'}
                value={monthFilter}
                onChange={e => setMonthFilter(e.target.value)}
            >
                <option value=''>
                    Todos los meses
                </option>
                {Array.from(new Set(
                    meetings.map(m => new Date(m.date).toISOString().slice(0, 7))
                )).map(m =>
                    <option key={m} value={m}>
                        {new Date(parseInt(m.split('-')[0]), parseInt(m.split('-')[1]) - 1).toLocaleDateString('es-ES', { month: 'long', year: 'numeric' }).toUpperCase()}
                    </option>
                )}
            </select>
        </div>
        </>
    )
}
